export default function Header() {
  const handleCTAClick = () => {
    window.open('https://lin.ee/luTEHR8', '_blank');
  };

  return (
    <header className="absolute top-0 left-0 right-0 z-50">
      <div className="flex items-start justify-between px-4 pt-4">
        <div className="flex-shrink-0">
          <img
            src="https://static.readdy.ai/image/be74474a88e32cc40cdef43b4d914c46/765474251b75aae3d75c66971441b410.png"
            alt="おうちの相談室"
            className="h-16 md:h-20 w-auto max-w-[calc(100vw-100px)]"
          />
        </div>
        <button
          onClick={handleCTAClick}
          className="hidden md:flex bg-[#F2A67E] text-white w-14 h-14 rounded-xl items-center justify-center hover:opacity-90 transition-opacity cursor-pointer flex-shrink-0"
        >
          <i className="ri-line-fill text-4xl"></i>
        </button>
      </div>
    </header>
  );
}